// Angular
import { Injectable } from '@angular/core'
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
// NGRX
import { select, Store } from '@ngrx/store'
// RxJS
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
// Auth reducers and selectors
import { AppState } from '../../../core/reducers/'
import { SplashScreenService } from '../../_base/layout/services/splash-screen.service'
import { Login } from '../_actions/auth.actions'
import { isLoggedIn } from '../_selectors/auth.selectors'
import { Location } from '@angular/common'

@Injectable()
export class AuthGuard implements CanActivate {
	adminvisu: string = '';
	constructor(
		private store: Store<AppState>,
		private router: Router,
		private route: ActivatedRoute,
		private splashScreenService: SplashScreenService,
		private location: Location
	) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.store
			.pipe(
				select(isLoggedIn),
				tap(loggedIn => {
					let params = new URLSearchParams(document.location.search);
					let splitLink = location.pathname.split(this.location["_baseHref"])
					let link = splitLink[1];
					let token = params.get("tokenAtyl");
					let isCropped = params.get("isCropped");

					if (!loggedIn && window.location.href.lastIndexOf('/admin/form/') !== -1) {
						let token = window.location.href.substring(window.location.href.lastIndexOf('token=') + 6, window.location.href.length)
						environment.tokenauth = token
						this.store.dispatch(new Login({ authToken: token }))
						this.router.navigateByUrl("/home/admin/form/" + window.location.href.substring(window.location.href.lastIndexOf('/admin/form/') + 12, window.location.href.lastIndexOf('?')))
					} else if (token && !loggedIn) {
						this.router.navigate(["/auth/login"], 
							{queryParams: {url: link, token: token, isCropped: isCropped}});
							
						/*window.addEventListener('beforeunload', () => {
						    // Notify the opener window
						    window.opener?.postMessage({ type: 'popup_closing',url:document.location }, window.location.origin);
						});*/	
							
					} else if (!loggedIn) {
						console.log("redirect login 1")
						this.router.navigate(["/auth/login"], 
							{queryParams: {url: link, isCropped: isCropped}});
					}
				})
			)
	}
}
